/** Speedometer/gauge glyph for the bar-raiser evaluation toolbar action. */
export function SpeedometerIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false">
      <g transform="scale(0.6667)">
        <path
          opacity="0.5"
          d="M19.775,7.226l-1.416,1.416c1.408,1.406,2.354,3.276,2.585,5.359H20c-0.553,0-1,0.447-1,1
            s0.447,1,1,1h2c0.553,0,1-0.447,1-1C23,11.967,21.766,9.218,19.775,7.226z"
        />
        <path
          d="M19.775,7.226l-1.416,1.416C16.952,7.236,15.082,6.292,13,6.061V7c0,0.552-0.448,1-1,1s-1-0.448-1-1V6.059
            C8.919,6.292,7.052,7.238,5.645,8.646C4.237,10.054,3.286,11.918,3.055,14H4c0.552,0,1,0.447,1,1s-0.448,1-1,1H2
            c-0.552,0-1-0.447-1-1c0-3.032,1.233-5.782,3.225-7.774C6.217,5.234,8.967,4,12,4C15.033,4,17.783,5.234,19.775,7.226z
            M16.489,12.163c-0.987,1.438-2.705,3.909-3.128,4.302C12.99,16.81,12.507,17,12,17c-0.554,0-1.089-0.233-1.466-0.639
            c-0.364-0.391-0.553-0.901-0.533-1.435s0.246-1.028,0.638-1.392c0.423-0.393,3.015-1.923,4.522-2.801
            c0.157-0.091,0.331-0.136,0.503-0.136c0.271,0,0.539,0.11,0.733,0.32C16.715,11.26,16.753,11.778,16.489,12.163z M12.733,14.32
            c-0.376-0.405-1.009-0.428-1.413-0.052c-0.405,0.376-0.428,1.008-0.052,1.413c0.193,0.207,0.453,0.311,0.715,0.316
            C11.988,15.996,11.994,16,12,16c0.076,0,0.151-0.024,0.226-0.042c-0.054,0.013-0.108,0.018-0.162,0.025
            c0.222-0.014,0.441-0.088,0.617-0.251C13.085,15.357,13.109,14.724,12.733,14.32z"
        />
      </g>
    </svg>
  );
}
